import { UploadedFile } from '@paragon/component-processor';

export function getFullName(file: UploadedFile) {
  if (!file.filetype) {
    return file.filename;
  }
  return `${file.filename}.${file.filetype}`;
}
